import { defineMessages } from 'react-intl';

export default defineMessages({
    notesSentToUnderwriterTitle: {
        id: 'wmic-pe-components-platform-react.WMICNotesForUnderwriterList.Notes sent to the underwriter',
        defaultMessage: 'Notes sent to the underwriter',
    },
});
